// @flow

import {iterateTree} from './iterateTree';

import type {TreeItem, TreeStructure} from '../typedef';


export function findRootParentNodeInTree(tree: TreeStructure, id: string): ?TreeItem {
    let rootParent;

    function getParent({
        parents,
        item
    }: { item: TreeItem, i: number, array: TreeStructure, parents: Array<TreeItem> }) {
        return item.id === id ? (rootParent = parents[0] || item) : undefined;
    }

    iterateTree(tree, getParent, 'find');
    return rootParent;
}
